import { render, staticRenderFns } from "./cashback-banner-v2.vue?vue&type=template&id=2594fd7b&scoped=true&lang=pug&"
import script from "./cashback-banner-v2.vue?vue&type=script&lang=js&"
export * from "./cashback-banner-v2.vue?vue&type=script&lang=js&"
import style0 from "./cashback-banner-v2.vue?vue&type=style&index=0&id=2594fd7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594fd7b",
  null
  
)

export default component.exports